export default __webpack_public_path__ + "static/media/11b.0b3cb217.png";